export const SETTINGS_SECTION_STYLES = {
  container: "bg-white rounded-lg p-6",
  header: "text-xl font-semibold mb-4 mt-0",
  subheader: "text-lg font-semibold mb-3 mt-6",
  helperText: "text-sm text-gray-500 mt-4",
  grid: "grid grid-cols-1 md:grid-cols-2 gap-4",
} as const
